import domReady from '@wordpress/dom-ready';
import EmblaCarousel from 'embla-carousel';
import { addDotBtnsAndClickHandlers } from './components/dots-navigation';
import { addPrevNextBtnsClickHandlers } from './components/buttons-navigation';
import { addThumbBtnsClickHandlers, addToggleThumbBtnsActive } from './components/thumbs-navigation';
import AutoScroll from 'embla-carousel-auto-scroll';
import Autoplay from 'embla-carousel-autoplay';

domReady(() => {
  const emblaViewportNodes = Array.from(document.querySelectorAll('.embla > .embla__viewport'));

  if (emblaViewportNodes.length) {
    emblaViewportNodes.forEach((emblaViewportNode) => {

      // Plugins (autoScroll)
      const plugins = [];
      if (emblaViewportNode.hasAttribute('data-auto-scroll')) {
        plugins.push(
          AutoScroll({
            speed: parseFloat(emblaViewportNode.getAttribute('data-auto-scroll-speed') || 1),
            playOnInit: true,
          })
        );
      }
      // AUTOPLAY
      if (emblaViewportNode.hasAttribute('data-autoplay')) {
        plugins.push(
          Autoplay({
            delay: parseInt(emblaViewportNode.getAttribute('data-autoplay-delay') || 3000, 10),
            stopOnInteraction: false,
            stopOnMouseEnter: true,
          })
        );
      }

      // Instanciate carousel
      const globalOptions = { dragFree: true, containScroll: 'trimSnaps' };
      const customOptions = emblaViewportNode.hasAttribute('data-carousel-options')
        ? JSON.parse(emblaViewportNode.getAttribute('data-carousel-options'))
        : {};
      const instanceOptions = { ...globalOptions, ...customOptions };
      const emblaApi = EmblaCarousel(emblaViewportNode, instanceOptions, plugins);

      /**
       * Met à jour toutes les slides visibles dans le viewport
       * et applique l'attribut slide-active
       */
      const updateActiveSlides = () => {
      const slides = emblaApi.slideNodes();
      const viewportRect = emblaViewportNode.getBoundingClientRect();

      // Tableau des slides visibles
      const visibleSlides = [];

      slides.forEach((slide) => {
        const slideRect = slide.getBoundingClientRect();

        // Vérifie si la slide est partiellement visible
        const isVisible =
          slideRect.right > viewportRect.left + viewportRect.width * 0.25 &&
          slideRect.left < viewportRect.right - viewportRect.width * 0.25;

        if (isVisible) {
          slide.setAttribute('slide-active', 'true');
          visibleSlides.push(slide); // ajout au tableau visible
        } else {
          slide.removeAttribute('slide-active');
        }

        // Supprime l'attribut slide-center par défaut
        slide.removeAttribute('slide-center');
      });

      // Attribue la slide du milieu
      if (visibleSlides.length > 0) {
        const middleIndex = Math.floor(visibleSlides.length / 2);
        visibleSlides[middleIndex].setAttribute('slide-center', 'true');
      }
    };

      // Écoute du scroll et du select pour mettre à jour en temps réel
      emblaApi.on('scroll', updateActiveSlides);
      emblaApi.on('select', updateActiveSlides);

      // Mise à jour initiale
      updateActiveSlides();

      // Navigation prev/next
      const prevBtn = emblaViewportNode.querySelector('.embla__navigation > .embla__button--prev');
      const nextBtn = emblaViewportNode.querySelector('.embla__navigation > .embla__button--next');

      if (prevBtn && nextBtn) {
        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, prevBtn, nextBtn);
        emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
      }

      // Dots navigation
      const dotsNode = emblaViewportNode.querySelector('.embla__dots');
      if (dotsNode) {
        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(emblaApi, dotsNode);
        emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
      }

      // Thumbs navigation
      const thumbsViewportNode = emblaViewportNode.querySelector('.embla__thumbs .embla__viewport');
      if (thumbsViewportNode) {
        const emblaApiThumb = EmblaCarousel(thumbsViewportNode, { dragFree: true, containScroll: 'trimSnaps' });

        const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(emblaApi, emblaApiThumb);
        const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(emblaApi, emblaApiThumb);

        emblaApi.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);
        emblaApiThumb.on('destroy', removeThumbBtnsClickHandlers).on('destroy', removeToggleThumbBtnsActive);

        // Buttons navigation thumbs
        const prevThumbBtn = thumbsViewportNode.querySelector(':scope > .embla__button--prev');
        const nextThumbBtn = thumbsViewportNode.querySelector(':scope > .embla__button--next');
        if (prevThumbBtn && nextThumbBtn) {
          const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApiThumb, prevThumbBtn, nextThumbBtn);
          emblaApiThumb.on('destroy', removePrevNextBtnsClickHandlers);
        }
      }
    });
  }
});
